<div class="commission-earned flex-column">
    <!-- header -->
    <div class="commission-earned-header flex-between-center border-bottom-lightest">
        <div class="header-info-section flex-column">
            <span class="font-18 font-600">Commission earned</span>
            <span class="font-14 font-400">Includes fully paid ROs only</span>
        </div>
        <span class="font-24 font-400 font-gray pointer" (click)="handleClose()">
            <i class="far fa-times"></i>
        </span>
    </div>
    <!-- body -->
    <div class="commission-earned-body flex-column">
        <!-- filter -->
        <div class="flex-between-center commission-filter">
            <div class="flex-row">
                <span class="font-16 font-400">Total commission:&nbsp;</span>
                <span class="font-16 font-700">{{ totalEarning?.totalSumAllDates || 0 | currency: usd}}</span>
            </div>
            <div class="flex-center-center">
                <span class="font-16 font-400">Filter:</span>
                <app-report-filter id="commission-earned"
                    [hasMultiLocationFilter]="false" heading=""
                    [hasExport]="false"
                    [options]="filterOptions"
                    [updateUrl]="false"
                    [notShowMobileView]="true"
                    (filterChange)="filterData($event)">
                </app-report-filter>
            </div>
        </div>
        <div class="commission-earned-detail flex-column">
            <div class="commission-detail-header flex-between-center">
                <span class="font-14 font-600">Date</span>
                <span class="font-14 font-600">Commission earned</span>
            </div>
            <div class="commission-detail-body flex-column">
                <ng-container *ngIf="!loading">
                    <div class="commission-earned-row-wrapper" *ngFor="let earning of earningRecords">
                        <p-accordion>
                            <p-accordionTab class="commission-earned-row">
                              <p-header>
                                <div class="flex-between-center commission-info-header">
                                  <span class="font-14 font-400">{{earning._id | date : 'EEEE - MMM d, yyyy'}}</span>
                                  <span class="font-14 font-600 mr-2">{{earning.totalSum || 0 | currency: usd }}</span>
                                </div>
                              </p-header>
                              <ng-template pTemplate="content">
                                  <div class="commission-ro-block mb-3" *ngFor="let order of earning.orders">
                                    <ul class="pl-0 mb-0">
                                      <li class="flex-between-center pb-1">
                                        <span class="font-12 font-600 ro-number pointer" (click)="openRO(order.order)">RO - {{order.orderCode}}
                                            <i class="fal fa-external-link-alt"></i>
                                        </span>
                                        <span class="font-12 font-600">{{order.totalCommissionEarned || 0 | currency: usd}}</span>
                                      </li>
                                      <li class="flex-between-center pb-1" *ngFor="let service of order.services">
                                        <span class="font-12 font-400 font-gray-35">{{service.title}}</span>
                                        <span class="font-12 font-400 font-gray-35">{{service.commissionEarned || 0 | currency: usd}}</span>
                                      </li>
                                    </ul>
                                  </div>
                              </ng-template>
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </ng-container>


                <div class="flex-column flex-center-center not-data-available" *ngIf="!earningRecords?.length && !loading">
                    <img src="assets/img/norecord.png" alt="">
                    <p>
                        No data available
                    </p>
                </div>
                <div class="flex-column flex-center-center not-data-available" *ngIf="loading">
                    <i class="fal fa-spinner rotate fa-2x"></i>
                </div>
            </div>
            <div class="commission-earned-footer border-top-lightest" *ngIf="earningRecords.length > 0 && totalRecords > pageSize">
                <p-paginator class="ui-g-12 p-0" [rows]="pageSize" [totalRecords]="totalRecords"
                    (onPageChange)="paginate($event)">
                </p-paginator>
            </div>
        </div>
    </div>
</div>
